<template>
  <div>
    <div v-if="isVerified" class="level level-left is-narrow">
      <span class="icon mdi mdi-check-circle has-text-success"></span>
      <span>{{ $t('phone_verification_status.confirmed') }}</span>
    </div>
    <div v-if="!isVerified" class="level level-left is-narrow">
      <span class="icon mdi mdi-alert-circle has-text-danger"></span>
      <span>{{ $t('phone_verification_status.notConfirmed') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhoneVerificationStatus",
  props: {
    isVerified: {
      type: Boolean,
      default: false
    }
  }
};
</script>
